import {FilledInputProps, OutlinedInputProps} from "@material-ui/core";
import {FieldProps, FunctionField, InputProps, Record, TextField, TextInput,} from "react-admin";
import {useStore} from "./store";
import {useForm} from "react-final-form";
import {FormApi} from "final-form";

export const EditableTextField = (
  props: FieldProps & {
    source: string;
    alwaysEditable?: boolean;
    getInputProps?: (
      record: Record,
      form: FormApi<
        globalThis.Record<string, any>,
        Partial<globalThis.Record<string, any>>
      >
    ) =>
      | Partial<InputProps>
      | Partial<FilledInputProps>
      | Partial<OutlinedInputProps>
      | undefined;
  }
) => {
  const { editable } = useStore();
  const form = useForm();
  const { getInputProps, alwaysEditable, ...rest } = props;
  return editable || alwaysEditable ? (
    <FunctionField
      {...rest}
      render={(record: Record | undefined) => (
        <TextInput
          size="small"
          fullWidth
          variant="outlined"
          label=""
          source={rest.source}
          helperText={false}
          multiline
          onClick={(e) => e.stopPropagation()}
          InputProps={
            getInputProps && record ? getInputProps(record, form) : undefined
          }
        />
      )}
    />
  ) : (
    <TextField {...rest} fullWidth />
  );
};
